import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=518afbb6&scoped=true"
import script from "./contents.vue?vue&type=script&lang=js"
export * from "./contents.vue?vue&type=script&lang=js"
import style0 from "./contents.vue?vue&type=style&index=0&id=518afbb6&prod&scoped=true&lang=css"
import style1 from "./contents.vue?vue&type=style&index=1&id=518afbb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518afbb6",
  null
  
)

export default component.exports